import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = user
  const [wishlist, setWishlist] = useState([]);

  const refreshWishlist = useCallback(async () => {
    try {
      const { data } = await api.get("/account/wishlist");
      setWishlist(data.map((p) => p.id));
    } catch {
      setWishlist([]);
    }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      refreshWishlist();
    } catch {
      setUser(false);
    }
  }, [refreshWishlist]);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      return; // AuthCallback handles it
    }
    checkAuth();
  }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data.user);
    refreshWishlist();
    return data.user;
  };
  const register = async (name, email, password) => {
    const { data } = await api.post("/auth/register", { name, email, password });
    setUser(data.user);
    return data.user;
  };
  const logout = async () => {
    await api.post("/auth/logout");
    setUser(false);
    setWishlist([]);
  };
  const toggleWishlist = async (product_id) => {
    const { data } = await api.post("/account/wishlist", { product_id });
    setWishlist(data.wishlist);
    return data.added;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, wishlist, login, register, logout, checkAuth, toggleWishlist, refreshWishlist }}>
      {children}
    </AuthContext.Provider>
  );
}
